import addBorderInHighContrastMode from '@/lib/styling/addBorderInHighContrastMode';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { Alert } from '@mui/material';

const ErrorModeDeletionWarning = styled(Alert)(
  {
    marginTop: 12,
  },
  addBorderInHighContrastMode,
  addHighContrastStyles({
    backgroundColor: 'transparent',
  }),
);

export default ErrorModeDeletionWarning;
